import React from 'react'
import { Badge, Button, Card } from 'react-bootstrap'
import { FaBirthdayCake, FaPen, FaPhoneAlt, FaRegCalendarCheck, FaWhatsapp } from 'react-icons/fa'
import { IoMailOutline } from 'react-icons/io5'
import { birthdayDayMonth, dateBR, isBirthdayToday, nameInitials, whatsappBirthdayLink } from '../../utilities/birthdays'
import { formatarTelefone } from '../../utilities/formatarTelefoneInput'

const BirthdayCard = ({ paciente, whatsappMessage, onEdit }) => {
  const today = isBirthdayToday(paciente.data_nascimento)
  const whatsappLink = whatsappBirthdayLink(paciente, whatsappMessage)
  const phone = paciente.telefone2 || paciente.telefone
  const greeting = paciente.greeting

  return (
    <Card className={`h-100 birthdays-card ${today ? 'birthdays-card-today' : ''}`}>
      <Card.Body className='p-2 d-flex flex-column gap-2'>
        <div className='d-flex align-items-start gap-2'>
          {paciente.foto ?
            <img src={paciente.foto} alt={paciente.nome} className='birthdays-avatar' loading='lazy' />
            :
            <div className='birthdays-avatar'>{nameInitials(paciente.nome)}</div>
          }

          <div className='d-flex flex-column flex-grow-1' style={{ minWidth: 0 }}>
            <span className='fw-semibold birthdays-card-name' title={paciente.nome}>{paciente.nome}</span>
            <div className='d-flex flex-wrap gap-1 mt-1'>
              <Badge bg='light' text='dark' className='border birthdays-badge'>
                <FaBirthdayCake size={10} /> {birthdayDayMonth(paciente.data_nascimento)}
              </Badge>
              <Badge bg='secondary' className='birthdays-badge'>
                {paciente.idade} {paciente.idade === 1 ? 'ano' : 'anos'}
              </Badge>
              {today ?
                <Badge className='birthdays-badge' style={{ backgroundColor: 'var(--birthdays-primary)' }} bg=''>Hoje</Badge>
                : ''}
              {greeting?.status === 'SENT' ?
                <Badge bg='success' className='birthdays-badge' title='E-mail de aniversário enviado neste ano'>
                  <IoMailOutline size={11} /> Enviado
                </Badge>
                : ''}
              {greeting?.status === 'FAILED' ?
                <Badge bg='danger' className='birthdays-badge' title={greeting.last_error || 'Não foi possível enviar o e-mail de aniversário'}>
                  <IoMailOutline size={11} /> Falha no envio
                </Badge>
                : ''}
            </div>
          </div>

          <Button variant='link' size='sm' className='p-1 text-secondary' title='Abrir cadastro' onClick={() => onEdit(paciente.id)}>
            <FaPen size={13} />
          </Button>
        </div>

        <div className='border-top pt-2 d-flex flex-column gap-1 mt-auto'>
          <div className='d-flex align-items-center gap-2 birthdays-card-info'>
            <FaPhoneAlt size={12} />
            {phone ?
              <span className='text-truncate'>{formatarTelefone(phone)}</span>
              :
              <span className='fst-italic'>Sem telefone</span>
            }
            {whatsappLink ?
              <Button
                variant='outline-success'
                size='sm'
                className='ms-auto py-0 px-2 text-nowrap d-flex align-items-center gap-1'
                href={whatsappLink}
                target='_blank'
                rel='noopener noreferrer'
                title='Abrir o WhatsApp com a mensagem de parabéns'
              >
                <FaWhatsapp /> Parabenizar
              </Button>
              : ''}
          </div>
          <div className='d-flex align-items-center gap-2 birthdays-card-info'>
            <IoMailOutline />
            {paciente.email ?
              <span className='text-truncate' title={paciente.email}>{paciente.email}</span>
              :
              <span className='fst-italic'>Sem e-mail</span>
            }
          </div>
          <div className='d-flex align-items-center gap-2 birthdays-card-info'>
            <FaRegCalendarCheck />
            {paciente.last_attendance ?
              <span className='text-truncate' title='Data mais recente na aba Atendimentos do prontuário'>Último atendimento: {dateBR(paciente.last_attendance)}</span>
              :
              <span className='fst-italic'>Nenhum atendimento encontrado</span>
            }
          </div>
        </div>
      </Card.Body>
    </Card>
  )
}

export default BirthdayCard
